/** Phase A marketplace business rules — locked 2026-05-25 */

export const MARKETPLACE_ELIGIBILITY_REASONS = [
  "SKU_NOT_FOUND",
  "SHOP_MISMATCH",
  "SKU_INACTIVE",
  "FITMENT_PENDING",
  "NO_STOCK",
  "LISTING_REMOVED",
  "MODERATION_HIDDEN",
  "MERCHANT_UNPUBLISHED",
] as const;

export type MarketplaceEligibilityReason =
  (typeof MARKETPLACE_ELIGIBILITY_REASONS)[number];

/** Fitment gate: catalog_skus.fitment_status must be `complete` */
export const MARKETPLACE_REQUIRES_FITMENT_COMPLETE = true;

/** Stock: sum (on_hand - reserved) across active branches; branch filter optional */
export const MARKETPLACE_STOCK_SUM_ALL_BRANCHES = true;

/** ປ້າຍ (Lao) ສຳລັບເຫດຜົນທີ່ publish marketplace ບໍ່ໄດ້ — ໃຊ້ຮ່ວມກັນ catalog + marketplace UI */
export const MARKETPLACE_ELIGIBILITY_REASON_LABELS: Record<
  MarketplaceEligibilityReason,
  string
> = {
  SKU_NOT_FOUND: "ບໍ່ພົບ SKU",
  SHOP_MISMATCH: "SKU ບໍ່ກົງກັບຮ້ານ",
  SKU_INACTIVE: "SKU ປິດໃຊ້ງານ",
  FITMENT_PENDING: "ລໍ Admin ຄີລຸ່ນລົດ / fitment",
  NO_STOCK: "ບໍ່ມີສະຕ໋ອກ",
  LISTING_REMOVED: "Admin ລຶບລາຍການແລ້ວ",
  MODERATION_HIDDEN: "Admin ປິດການສະແດງ",
  MERCHANT_UNPUBLISHED: "ຮ້ານຖອນຈາກ marketplace",
};

/** ປ້າຍສຳລັບເຫດຜົນເພີ່ມເຕີມທີ່ມາຈາກ UI/sync (ບໍ່ຢູ່ໃນ eligibility ຫຼັກ) */
export const MARKETPLACE_EXTRA_REASON_LABELS: Record<string, string> = {
  AUTO_PUBLISH_OFF: "ປິດ auto-publish",
};

/** ແປ reason code → ປ້າຍ Lao (fallback = code ດິບ) */
export function marketplaceReasonLabel(code: string): string {
  return (
    MARKETPLACE_ELIGIBILITY_REASON_LABELS[
      code as MarketplaceEligibilityReason
    ] ??
    MARKETPLACE_EXTRA_REASON_LABELS[code] ??
    code
  );
}

export type FitmentStatus = "pending" | "complete";

/** ປ້າຍ fitment status (Lao) */
export const FITMENT_STATUS_LABELS: Record<FitmentStatus, string> = {
  pending: "ລໍ Admin ຄີ fitment",
  complete: "fitment ຄົບ",
};
